module.exports = __webpack_public_path__ + "static/media/westpac-logo.9881ec51.png";